import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { EditOutlined } from '@ant-design/icons'
import ButtonComponent from '@BUP/components/Generics/Buttons/button-component'
import ModalComponent from '@BUP/components/Generics/Modal'
import EditTeacherForm from '@BUP/components/MySchool/EditTeacherForm'

const EditTeacherButton = ({
  user,
  courses,
  isMultiCourse
}) => {
  const [stateModal, setStateModal] = useState(false)
  const i18n = useTranslation()

  return (
    <>
      <ButtonComponent
        colorType='primary'
        onClick={() => setStateModal(true)}
        buttonText={<EditOutlined />}
        size='small'
        disabled={isMultiCourse}
      />
      <ModalComponent
        header
        headerText={`${i18n.t('common.resources.user.actions.edit.submit')} ${user ? user.name : '--'}`}
        stateModal={stateModal}
        modalDescription={
          <EditTeacherForm
            selectedUser={user}
            courses={courses}
            setStateModal={setStateModal}
            isMultiCourse={isMultiCourse}
          />
        }
        showButtons={false}
        onClickCloseModal={() => setStateModal(false)}
      />
    </>
  )
}

export default EditTeacherButton
